<template>
  <router-link to="/" class="c-header-bar-logo" itemprop="url" aria-label="logo">
    <div ref="logo"></div>
  </router-link>
</template>

<script>
import lottie from "lottie-web";
export default {
  mounted() {
    this.setAnimation();
  },
  data() {
    return {
      logoAnimation: null,
      autoplay: true
    };
  },
  methods: {
    setAnimation() {
      // Destroy autoplaynimation if exists
      if (this.logoAnimation) {
        this.logoAnimation.destroy();
      }

      this.logoAnimation = lottie.loadAnimation({
        container: this.$refs.logo,
        renderer: "svg",
        autoplay: false,
        loop: false,
        animationData: require(`assets/animations/${this.$root.$i18n.locale}/logo.json`)
      });

      if (this.autoplay) {
        this.logoAnimation.play();
      }
    }
  }
};
</script>

<style lang="scss">
.c-header-bar-logo {
  display: flex;
  justify-self: center;
  align-items: center;
  width: 100%;
  height: 100%;
  max-width: 133px;

  @media #{$breakpoint-horizontal} {
    position: absolute;
    transform: rotate(-90deg);
    height: $header-width--no-padding;
    transform-origin: 0% 0%;

    min-width: 133px;
    max-width: 140px;
  }
  div {
    width: 100%;
    height: 100%;
    @media #{$breakpoint-horizontal} {
      @include transform(translate(-25%, 0px));
    }

    svg {
      path {
        @include transition(0.3s ease all);
        fill: $color-white;
        .header-bar--scrolled & {
          fill: $color-lighter;
        }
      }
    }
  }
}
</style>
